export default (theme) => ({
  cardButton: {
    cursor: "pointer",
    width: "fit-content",
    backgroundColor: "white !important",
    borderWidth: "1px",
    color: `${theme.secondaryColor} !important`,
    padding: "4px 9px !important",
    borderRadius: "5px",
    borderColor: theme.secondaryColor,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "14px",
    fontSize: "14px",
    margin: "2px",
    transition: "0.3s",
    "&:hover": {
      color: "white !important",
      backgroundColor: `${theme.secondaryColor} !important`,
      borderColor: theme.secondaryColor,
    },
  },
});
